import { Component, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { NavigationExtras, Router } from '@angular/router';
import { CommonFunctions } from 'src/app/shared/common-functions';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
declare var dataLayer;
@Component({
  selector: 'app-terms-and-conditions-listing',
  templateUrl: './terms-and-conditions-listing.component.html',
  styleUrls: ['./terms-and-conditions-listing.component.scss']
})
export class TermsAndConditionsListingComponent implements OnInit {
  public breadCrumbData: Array<Object> = [
    { title: 'Home', path: 'dashboard' },
    { title: 'Terms of Use & Privacy Policy', path: '' }
  ];
  public tncData: any;
  public isMobile: boolean;
  public viewTncData: any;
  public tnCData: any;
  public pageTitle: any;
  public updatedDateTime: any;
  public showListing: boolean = true;
  userType: string;
  userId: any;
  tierType: any;
  constructor(
    private router: Router,
    private auth: AuthenticationService,
    private commonFunction: CommonFunctions,
    private _bottomSheet: MatBottomSheet
  ) { 
    this.isMobile = this.commonFunction.identifyDeviceType();
    this.userType = this.commonFunction.getUserType();
    this.userId = this.commonFunction.getUserId();
    this.tierType = this.commonFunction.getTierType();
  }
  ngOnInit(): void {
    this.getTncData();
  }
  public getTncData() {
    this.commonFunction.showLoader();
    this.auth.getTncData().subscribe((result: any) => {
      this.tncData = result.response.data;
      this.commonFunction.hideLoader();
    }, (error) => {
      this.commonFunction.hideLoader();
      this.commonFunction.processErrorMessage(error, 'failure')
    })
  }
  goToView(index){
    this.showListing=false;
    this.viewTncData=this.tncData[index];
    this.tnCData = this.viewTncData.attributes.text;
    this.pageTitle = this.viewTncData.attributes.title;
    this.updatedDateTime = this.viewTncData.attributes.updatedDateTime;
  }
  closeSheet() {
    this._bottomSheet.dismiss()
  }
  gotoListing(){
    this.showListing=true;
  }
  crossBtnGA(){
    dataLayer.push({
      'event':'cross_click',
      'userID':this.userId,
      'user_type':this.userType,
      'tier':this.tierType
    })
  }
}